// @flow
import {Next} from "../MiddlewareUtils";
import type {Store} from "redux";
import type {Action} from "../../Ducks/DucksUtils";
import BackendOperations from "../Backend/operations";
import type {State} from "../../Store";

const buildCrashObject = (stateBefore: State, action: Action, err: Object): Object => {
    return {
        error: {
            message: (err && err.message) ? err.message : err.toString(),
            stack: (err && err.stack) ? err.stack : undefined,
        },
        stateBefore: stateBefore,
        action: action,
    };
};

/**
 * When used as a middleware, whenever a reducer operation fails, the crash is sent to the API
 * @param store: Store
 * @returns {function(Next): Function}
 */
const middleware = (store: Store) => (next: Next) => (action: Action) => {
    const stateBefore = store.getState();
    try {
        return next(action); // dispatch
    } catch (err) {
        const crashObject = buildCrashObject(stateBefore, action, err);
        store.dispatch(BackendOperations.doSendLogToBackend(crashObject, "redux/crash"));
        throw err; // re-throw error
    }
};

export default middleware;


// WEBPACK FOOTER //
// ./src/Store/Middleware/CrashReporter/middleware.js